export interface SubmitOutcome {
  ok: boolean;
  message: string;
}

interface FormResponse {
  code?: string;
  message?: string;
  meta?: {
    message?: string;
    detail?: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

/**
 * Submits a Readdy form. Reads the payload directly from the DOM form element so
 * browser AutoFill values are included, checks the honeypot field first, and only
 * reports success when the server returns a 2xx with code === "OK".
 */
export async function submitForm(
  formEl: HTMLFormElement,
  submitAddr: string,
  honeypotName: string,
): Promise<SubmitOutcome> {
  const formData = new FormData(formEl);
  const honeypot = String(formData.get(honeypotName) ?? '').trim();

  // Client-side honeypot hit: silently behave like success, never send the request.
  if (honeypot) {
    return { ok: true, message: '' };
  }
  formData.delete(honeypotName);

  const params = new URLSearchParams();
  formData.forEach((value, key) => params.append(key, String(value)));

  try {
    const response = await fetch(submitAddr, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    });
    const responseText = await response.text();

    let parsed: FormResponse | null = null;
    try {
      parsed = JSON.parse(responseText) as FormResponse;
    } catch {
      parsed = null;
    }

    const serverMsg =
      parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
    const isSpam = String(serverMsg).toLowerCase().includes('spam');
    const success = response.ok && parsed?.code === 'OK' && !isSpam;

    if (success) {
      return { ok: true, message: '' };
    }
    return { ok: false, message: serverMsg || '提交失败，请稍后重试。' };
  } catch {
    return { ok: false, message: '网络异常，请稍后重试。' };
  }
}